const DEFAULT_ASSET_PATH = "/assets";
function joinAssetPath(basePath, assetPath) {
    const normalizedBasePath = basePath.replace(/\/+$/, "");
    const normalizedAssetPath = assetPath
        .replace(/^\/+/, "")
        .replace(/^assets\/+/, "");
    return `${normalizedBasePath}/${normalizedAssetPath}`;
}
export function getAssetPath(assetPath) {
    return joinAssetPath(window.__assetPath__ || DEFAULT_ASSET_PATH, assetPath);
}
export function getImageAssetPath(assetPath) {
    return getAssetPath(`images/${assetPath.replace(/^\/+/, "")}`);
}
export function getIconAssetPath(assetPath) {
    return getAssetPath(`icons/${assetPath.replace(/^\/+/, "")}`);
}
